var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mb-n4 mt-n3",attrs:{"fluid":""}},[_c('v-breadcrumbs',{staticClass:"breadcrumbs",attrs:{"items":_vm.breadcrumbs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }